const comercial = (acao) => ({ modulo: 'comercial', acao });
export const GPTA_FORMULA_PACKS_PAGE_PERMISSIONS = [
    comercial('visualizar_gpta_formulas'),
    comercial('configurar_gpta_formulas'),
];
export const GPTA_FORMULA_PACKS_WRITE_PERMISSIONS = [
    comercial('configurar_gpta_formulas'),
];
export function canAccessGptaFormulaPacks(hasPermission) {
    return GPTA_FORMULA_PACKS_PAGE_PERMISSIONS.some(permission => hasPermission(permission.modulo, permission.acao));
}
export function canConfigureGptaFormulaPacks(hasPermission) {
    return hasPermission('comercial', 'configurar_gpta_formulas');
}
